import { formatDate } from '../../../../utils/dateFormat';
export { formatDate };

// Memoized status renderer
export const renderStatus = (value) => {
  const getStatusStyle = (status) => {
    switch(status?.toUpperCase()) {
      case 'UNAUTHORISE':
        return 'bg-yellow-100 text-yellow-800';
      case 'OPSAUTHORISED':
        return 'bg-blue-100 text-blue-800';
      case 'ACTIVE':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <span className={`px-2 py-1 rounded-full text-base ${getStatusStyle(value)}`}>
      {value || "-"}
    </span>
  );
};

// Memoized columns configuration
export const FINAL_EXIT_COLUMNS = [
  { key: 'serial', title: 'S.NO.', searchable: false },
  { key: 'point_of_hire', title: 'POINT OF HIRE', searchable: true },
  { key: 'candidate_id', title: 'EMPLOYEE ID', searchable: true },
  { key: 'name', title: 'EMPLOYEE NAME', searchable: true },
  { key: 'nationality', title: 'NATIONALITY', searchable: true },
  { key: 'actual_profession', title: 'ACTUAL PROFESSION', searchable: true },
  { key: 'visa_profession', title: 'VISA PROFESSION', searchable: true },
  { key: 'basic_salary', title: 'BASIC', searchable: false },
  { key: 'salary_placeholder', title: 'SALARY', searchable: false },
  { key: 'total_salary', title: 'TOTAL SALARY', searchable: false },
  { key: 'client', title: 'CLIENT', searchable: true },
  { key: 'visa_provider', title: 'VISA PROVIDER', searchable: true },
  { key: 'iqama_number', title: 'IQAMA NUMBER', searchable: true },
  {
    key: 'iqama_expiry_date_g',
    title: 'IQAMA EXPIRY DATE',
    searchable: false,
    render: formatDate
  },
  { key: 'demobilization_type', title: 'STATUS', searchable: true },
  { key: 'demobilization_comments', title: 'FINAL REMARKS', searchable: false },
  { key: 'action', title: 'ACTION', searchable: false }
];

// Constants for better maintainability
export const FINAL_EXIT_CONFIG = {
  API_ENDPOINT: "/mobilization/finalExitFormalitiesQueue",
  DOWNLOAD_ENDPOINT: "/mobilization/excelDownload",
  DOWNLOAD_FILENAME: "Exit_formalities_summary",
  SEARCH_PLACEHOLDER: "Search across all columns...",
  NO_DATA_MESSAGE: "No final exit data available",
  DEBOUNCE_MS: 300,
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 500, 1000]
};

// Memoized searchable fields derived from columns
export const FINAL_EXIT_SEARCHABLE_FIELDS = FINAL_EXIT_COLUMNS
  .filter(col => col.searchable)
  .map(col => col.key);
